// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38xI0","toggle":"styles_toggle__1W1pI","preview":"styles_preview__3j4IG"};